import { IAirport } from '@move-frontend/dap';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { BaseCell, BaseHeader } from './Column';
import { FlightListScope } from '../../../domain/constants/FlightListScope';
import { Responsive } from '../../../../../../ui';

interface IHeaderProps {
	scope: FlightListScope;
}
interface ICellProps {
	airport: string;
	airportDetails?: IAirport;
}

const styles = css`
	min-width: 260px;
	display: flex;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		min-width: auto;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	font-weight: 500;
`;

export function Header({ scope }: IHeaderProps) {
	return (
		<StyledHeader>
			{scope === FlightListScope.Arrivals ? 'Origin' : 'Destination'}
		</StyledHeader>
	);
}

export function Cell({ airportDetails, airport }: ICellProps) {
	return (
		<StyledCell>
			{airportDetails
				? `${airportDetails.city} ${airportDetails.iata}`
				: airport}
		</StyledCell>
	);
}
